import React from "react";
import { Box } from "@mui/material";
import styles from "./socDashboard.module.scss";
import SocStats from "./SocStats";
import SocAlertTimeline from "./SocAlertTimeline";
import SocRecentAlerts from "./SocRecentAlerts";

const SocDashboard = () => {
  return (
    <Box className={styles.page}>
      <SocStats />
      <SocAlertTimeline />
      <SocRecentAlerts />
    </Box>
  );
};

export default SocDashboard;
